import Skeleton from '@mui/material/Skeleton';

import './index.scss';

export default function PreloaderTable(props) {
    const {size} = props;

    const rows = size ? Array.apply(null, Array(size)).map((y, i) => i + 1) : [1,2,3,4,5,6];
    return <div className='PreloaderTable'>
        {(props.rows || rows).map(i => <Skeleton key={`preloader_table_item_${i}`} variant="rectangular" width={'100%'} height={50} style={{marginBottom: '1rem'}} />)}
    </div>
}
